import mixin from './eye4insight.com';

export default mixin;
